import React, { useEffect, useState } from 'react';
import StyledOverview, { StyledOverviewWrapper } from './Styles';

import VehicleInfo from './VehicleInfo';
import MultiMedia from './MultiMedia';
import TransportContainer from '../TransportContainer';
import { TradeContext, TradeState } from '../../../_shared/types/trade';
import PendingFooter from './PendingFooter';

const Overview = ({
  tradeDetails,
  mediaList,
  element,
  badges,
  tradeId,
  tradeContext,
  tradeState,
  isOMP
}) => {
  const [showFooter, setShowFooter] = useState(false);

  const isSelling = tradeContext === TradeContext.Sell;

  useEffect(() => {
    const newShowFooter =
      [TradeState.pending, TradeState.closing].includes(
        tradeDetails.tradeState
      ) && isSelling;

    if (newShowFooter !== showFooter) {
      setShowFooter(newShowFooter);
    }
  }, [tradeDetails, showFooter, isSelling]);

  return (
    <StyledOverview id="overview">
      <StyledOverviewWrapper isSelling={isSelling}>
        <MultiMedia
          mediaList={mediaList}
          tradeDetails={tradeDetails}
          tradeId={tradeId}
          tradeContext={tradeContext}
          tradeState={tradeState}
        />
        <VehicleInfo
          tradeDetails={tradeDetails}
          tradeId={tradeId}
          tradeContext={tradeContext}
          tradeState={tradeState}
          isOMP={isOMP}
        />
        <div ref={element} />
        {!isSelling && (
          <TransportContainer
            tradeDetails={tradeDetails}
            type="info"
            badges={badges}
            tradeId={tradeId}
            isOMP={isOMP}
          />
        )}
      </StyledOverviewWrapper>
      {showFooter && (
        <PendingFooter tradeDetails={tradeDetails} isOmp={isOMP} />
      )}
    </StyledOverview>
  );
};

export default Overview;
